import VideoOptions from "%/dynamic-components/render-engine/bundles/video-options";
import Autoplay from "%/dynamic-components/render-engine/options/video-options/autoplay";
import Controls from "%/dynamic-components/render-engine/options/video-options/controls";
import Muted from "%/dynamic-components/render-engine/options/video-options/muted";
import Poster from "%/dynamic-components/render-engine/options/video-options/poster";
import SingleVideo from "%/dynamic-components/render-engine/options/video-options/single-video";
import Loop from "%/dynamic-components/render-engine/options/video-options/loop";
import BorderOptions from "%/dynamic-components/render-engine/bundles/border-options";
import BorderColor from "%/dynamic-components/render-engine/options/border-options/border-color";
import BorderWidth from "%/dynamic-components/render-engine/options/border-options/border-width";
import BorderRadius from "%/dynamic-components/render-engine/options/border-options/border-radius";
import LayoutWidthHeightOptions from "%/dynamic-components/render-engine/bundles/layout-width-height-options";
import LayoutHeight from "%/dynamic-components/render-engine/options/layout-options/layout-height";
import LayoutWidth from "%/dynamic-components/render-engine/options/layout-options/layout-width";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import BorderSides from "%/dynamic-components/render-engine/options/border-options/border-sides";
import EffectsOptions from "%/dynamic-components/render-engine/bundles/effects-options";
import BoxShadow from "%/dynamic-components/render-engine/options/box-shadow-options/box-shadow";
import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import MinHeight from "%/dynamic-components/render-engine/options/spacing-options/min-height";
import MaxHeight from "%/dynamic-components/render-engine/options/spacing-options/max-height";
import MinWidth from "%/dynamic-components/render-engine/options/spacing-options/min-width";
import MaxWidth from "%/dynamic-components/render-engine/options/spacing-options/max-width";
import AnimationEffectsOptions from "%/dynamic-components/render-engine/bundles/animation-effects-options";
import ClickAction from "%/dynamic-components/render-engine/options/click-actions/click-action";
import { GestureActionsMixin } from "%/dynamic-component-editor/standard-elements/click-actions/gesture-actions-mixin";

export const SingleVideoElementMixin = {
  elementPanelSettings: {
    displayIcon: "video",
    elementType: "element",
  },
  mixins: [GestureActionsMixin],
  optionBundles: [
    new LayoutWidthHeightOptions({
      "default.layout-width": 300,
    }),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
    VideoOptions,
    BorderOptions,
    new EffectsOptions({}, {
      "text-shadow": true,
    }),
    AnimationEffectsOptions,
  ],
  options: [
    ClickAction,
  ],
  data() {
    return {
      ClickAction,
      SingleVideo,
      Autoplay,
      Loop,
      Controls,
      Muted,
      Poster,
      LayoutWidth,
      MinWidth,
      MaxWidth,
      LayoutHeight,
      MinHeight,
      MaxHeight,
      BorderColor,
      BorderWidth,
      BorderRadius,
    };
  },
  methods: {
    // Every video variant hands the same player over, so a media behaviour
    // cannot depend on which twin happened to render.
    gestureMedia() {
      return this.$refs.video ?? null;
    },
  },
  computed: {
    myBorderRadius() {
      return this.getOptionValue(BorderRadius);
    },
    myBorderSides() {
      return this.getOptionValue(BorderSides);
    },
    videoStyleOverrides() {
      return {
        borderRadius: this.myBorderRadius,
        boxShadow: this.getOptionValue(BoxShadow),
        boxShadowHover: this.getOptionValue(BoxShadow, BaseOption.$states.HOVER),
      };
    },
  },
};
